/* eslint-disable */
import axios from '../../../shared/utils/axios-init';

const perPage = 25;

// fake data
const fakeData = {
  output: [
    {
      date: 1534378962,
      timestamp: 1534378962,
      currency: 'UAH',
      sum: 250.435,
      status: 'Pending',
      wallet: 'skfjsdk450405'
    },
    {
      date: 1534378212,
      timestamp: 1534378212,
      currency: 'USD',
      sum: 4350.435,
      status: 'Completed',
      wallet: '0l45l45'
    },
    {
      date: 1534377858,
      timestamp: 1534377858,
      currency: 'UAH',
      sum: 250.435,
      status: 'Pending',
      wallet: 'skfjsdk450405'
    },
    {
      date: 1534275627,
      timestamp: 1534275627,
      currency: 'USD',
      sum: 4350.435,
      status: 'Completed',
      wallet: '0l45l45'
    },
  ],
  deposit: [
    {
      date: 1533491140,
      currency: 'USD',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1533491140,
      currency: 'ADA',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534275627,
      currency: 'USD',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534275627,
      currency: 'UAH',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534257999,
      currency: 'ETH',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534257726,
      currency: 'USD',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534257656,
      currency: 'USD',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
    {
      date: 1534257641,
      currency: 'USD',
      sum: 9.94454,
      status: 'Completed',
      wallet: 'dlsfl4544403403'
    },
  ]
}



const initialState = {
  output: [],
  deposit: [],

  withdrawTableData: [],
  withdrawTablePagesLength: 1,
  withdrawTablePaginationPage: 1,
  replenishTableData: [],
  replenishTablePagesLength: 1,
  replenishTablePaginationPage: 1,
  currencies: [],
  transactionDialogOpen: false,
};

const getters = {
  getOutputData: state => state.output,
  getDepositeData: state => state.deposit,
  getTransactionDialogState: state => state.transactionDialogOpen,
};

const mutations = {
  setHistoryData(state, data) {
    state.output = data.output;
    state.deposit = data.deposit;
  },

  setTransactionDialogState(state, payload) {
    state.transactionDialogOpen = payload;
  },

  updateWithdrawTableData(state, payload) {
    state.withdrawTableData = payload;
  },

  updateWithdrawTablePaginationPage(state, payload) {
    state.withdrawTablePaginationPage = payload;
  },

  updateReplenishTableData(state, payload) {
    state.replenishTableData = payload;
  },

  updateReplenishTablePaginationPage(state, payload) {
    state.replenishTablePaginationPage = payload;
  },


  updateCurrencies(state, payload) {
    state.currencies = [{ code: 'All', id: '' }, ...payload];
  },

  updateWithdrawTablePagesLength(state, payload) {
    state.withdrawTablePagesLength = payload;
  },
  updateReplenishTablePagesLength(state, payload) {
    state.replenishTablePagesLength = payload;
  },
};

const actions = {
  async fetchHistoryData({ commit }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/cabinet/withdraw/list', null, { headers: { Authorization: `Bearer ${token}` } });
      commit('setHistoryData', fakeData);
    } catch (err) {

      console.log(err)
      commit('setFinanceData', []);
    }
  },
  async fetchInitialData({ commit }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.post('/cabinet/withdraw/list', { per_page: perPage }, { headers: { Authorization: `Bearer ${token}` } });
      commit('updateWithdrawTableData', data.list.data);
      commit('updateCurrencies', data.currencies.sort((a, b) => {
        if (a.code < b.code) {
          return -1;
        } else {
          return 1;
        }
      }));

      commit('updateWithdrawTablePagesLength', data.list.last_page);
    } catch (e) {
      console.dir(e);
    }
  },

  async updateWithDrawTableData({ commit }, payload) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');

      const { data } = await axios.post(
        '/cabinet/withdraw/list',
        Object.assign(
          {},
          { per_page: perPage },
          { ...payload }),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      commit('updateWithdrawTableData', data.list.data);
      commit('updateWithdrawTablePagesLength', data.list.last_page);
    } catch (e) {
      console.dir(e);
    }
  },
  async updateReplenishTableData({ commit }, payload) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');

      const { data } = await axios.post(
        '/cabinet/replenish/list',
        Object.assign(
          {},
          { per_page: perPage },
          { ...payload }),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      commit('updateReplenishTableData', data.list.data);
      commit('updateReplenishTablePagesLength', data.list.last_page);
    } catch (e) {
      console.dir(e);
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/history.js